/**
 * @internal
 */
export const CONVOY_API_URL = "https://dashboard.getconvoy.io/api/v1";

/**
 * @internal
 */
export const BASE_API_URL =
  "https://streampay-checkout-production.up.railway.app/api/v1";
